<ng-container *ngIf="!typeUser">
  <app-topbar></app-topbar>
  <router-outlet></router-outlet>
</ng-container>

<div class="container-fluid" *ngIf="typeUser">
  <router-outlet></router-outlet>
</div>